var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0931 9.31563L21.283 0H19.342L12.231 8.08844L6.5511 0H0L8.58901 12.2313L0 22H1.94095L9.45075 13.4583L15.4489 22H22L13.0925 9.31563H13.0931ZM10.4348 12.3389L9.5644 11.121L2.64022 1.42966H5.62138L11.209 9.251L12.0792 10.4689L19.3429 20.6353H16.3621L10.4348 12.3394V12.3389Z",
    fill: "#005F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBlue);
export default __webpack_public_path__ + "static/media/X-Blue.b679922256c3785c88d865d47563583a.svg";
export { ForwardRef as ReactComponent };